define(
    'utils/is-fixed',['jquery'],

    function ($) {
        /**
         * Checks if an element is fixed either by itself or
         * by it's parent(s)
         *
         * @class isFixed
         * @method isFixed
         * @param el
         */
        return function (el) {
            var els = el.add(el.parents()),
                isFixed = false;

            els.each(function () {
                if ($(this).css('position') === 'fixed') {
                    isFixed = true;
                    return false;
                }
            });

            return isFixed;
        };
    }
);
